import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AddOnApiModel } from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export abstract class AddOnService<TApiModel extends AddOnApiModel> {
  public readonly apiUrl = 'add-ons/';
  public abstract readonly prefix: string;

  public constructor(protected readonly http: HttpClientService) {}

  public get(): Observable<TApiModel> {
    return this.http.get<TApiModel>(`${this.apiUrl}${this.prefix}`);
  }
}
